/**
 * Маркер узла (угла стен). Показывается только в режиме выделения —
 * за него тянут угол, и все примыкающие стены перестраиваются вместе с ним.
 * Радиус задан в пикселях экрана, чтобы маркер не менялся при зуме.
 */
import type { PointerEvent } from "react";
import type { PlanNode } from "@/shared/plan";

interface Props {
	node: PlanNode;
	selected: boolean;
	mmPerPx: number;
	onPointerDown: (e: PointerEvent<SVGCircleElement>) => void;
}

export const NodeHandle = ({ node, selected, mmPerPx, onPointerDown }: Props) => {
	return (
		<circle
			data-role="node"
			cx={node.x}
			cy={node.y}
			r={(selected ? 7 : 5) * mmPerPx}
			fill={selected ? "#2f6feb" : "#ffffff"}
			stroke="#2f6feb"
			strokeWidth={1.5 * mmPerPx}
			style={{ cursor: "grab" }}
			onPointerDown={onPointerDown}
		/>
	);
};
